import React, { useId } from "react";
import { cx } from "../../../style";
import "./Input.css";

/**
 * Input — текстовое поле дизайн-системы.
 *
 * @param {string}  [label]            Подпись над полем.
 * @param {boolean} [required]         Показать * у подписи.
 * @param {("sm"|"md"|"lg")} [size="md"]
 * @param {React.ReactNode} [icon]     Иконка слева внутри поля.
 * @param {string}  [error]            Текст ошибки (красит рамку и показывается снизу).
 * @param {string}  [hint]             Подсказка снизу (если нет ошибки).
 * @param {boolean} [fullWidth]        Растянуть контейнер на всю ширину.
 * @param {string}  [wrapClassName]    Классы на контейнер .ui-field.
 * @param {object}  [wrapStyle]        inline-стиль контейнера.
 * @param {string}  [className]        Классы на сам <input>.
 * @param {object}  [style]            inline-стиль <input>.
 * Остальные пропсы (value, onChange, placeholder, type, disabled...) идут на <input>.
 */
const Input = React.forwardRef(function Input(
  {
    label,
    required = false,
    size = "md",
    icon = null,
    error,
    hint,
    fullWidth = false,
    id,
    wrapClassName,
    wrapStyle,
    className,
    style,
    ...rest
  },
  ref,
) {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <div
      className={cx("ui-field", fullWidth && "ui-field--full", wrapClassName)}
      style={wrapStyle}
    >
      {label && (
        <label className="ui-field__label" htmlFor={inputId}>
          {label}
          {required && <span className="ui-field__required">*</span>}
        </label>
      )}

      <div className="ui-input-wrap">
        {icon && <span className="ui-input-wrap__icon">{icon}</span>}
        <input
          ref={ref}
          id={inputId}
          className={cx(
            "ui-input",
            `ui-input--${size}`,
            icon && "ui-input--with-icon",
            error && "ui-input--error",
            className,
          )}
          style={style}
          aria-invalid={error ? true : undefined}
          {...rest}
        />
      </div>

      {error ? (
        <span className="ui-field__error">{error}</span>
      ) : hint ? (
        <span className="ui-field__hint">{hint}</span>
      ) : null}
    </div>
  );
});

export default Input;
